import React, { createContext, useContext, useMemo, useState } from "react";

type UnreadMessagesContextType = {
    count: number;
    setNewCount: (newVal: number) => void;
};

const UnreadMessagesContext = createContext<UnreadMessagesContextType | undefined>(undefined);

export const UnreadMessagesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [count, setCount] = useState(0);

    const setNewCount = (newVal: number) => setCount(newVal);
    const value = useMemo(() => ({ count, setNewCount }), [count]);
    return (
        <UnreadMessagesContext.Provider value={value}>
            {children}
        </UnreadMessagesContext.Provider>
    );
};

export const useUnreadMessages = () => {
    const context = useContext(UnreadMessagesContext);
    if (!context) {
        throw new Error("useUnreadMessages must be used within an UnreadMessagesProvider");
    }
    return context;
};
